export default "__VITE_ASSET__ee00c244__"